import React from 'react';
import {WithPermission} from 'admin-on-rest';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {resolveAccess} from '../shared/authFunctions';
import {Card, CardHeader, CardText, CardActions} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Avatar from 'material-ui/Avatar';
import ListIcon from 'material-ui/svg-icons/action/view-list';
import AddIcon from 'material-ui/svg-icons/content/add';
import KitIcon from 'material-ui/svg-icons/hardware/tablet-android';
import {fusePosKitIcon as POSKitIcon} from './posKit';
import {dashStyles} from '../shared/styles-dashboard';

export default () => (
    <div>
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_kit', 'pos_kit_vo'])}>
            <Card style={{...dashStyles.marginBottom}}>
                <KitIcon style={dashStyles.dashIcon}/>
                <ViewTitle title="Kits"/>
                <CardText>
                    <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_kit'])}>
                        <p>
                            Create and Manage all of your POS Kits for your Business.
                        </p>
                    </WithPermission>
                    <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['pos_kit_vo'])}>
                        <p>
                            View all of your POS Kits for your Business.
                        </p>
                    </WithPermission>
                </CardText>
            </Card>
        </WithPermission>

        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_kit', 'pos_kit_vo'])}>
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}} className="listCard">
                <CardHeader
                    title="POS Kits"
                    subtitle="A POS Kit holds your device's information and location it's assigned to."
                    avatar={<Avatar icon={<POSKitIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_kit'], [])}>
                        <FlatButton icon={<ListIcon/>} label="List POS Kits" href="#/POSKits"/>
                        <FlatButton icon={<AddIcon/>} label="Add a POS Kit" href="#/POSKits/create"/>
                    </WithPermission>
                    <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['pos_kit_vo'])}>
                        <FlatButton icon={<ListIcon/>} label="List POS Kits" href="#/POSKits"/>
                    </WithPermission>
                </CardActions>
            </Card>
        </WithPermission>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/Kit/dashboard.js